import { createApp } from 'vue';
import components from './components.js';

/**
 * Create a fresh Vue application instance and attach it to the page
 */
createApp({
    components: {
        ...components,
    },
}).mount('#app');

// Fetch all the details element.
const details = document.querySelectorAll("details");

// Add the onclick listeners.
details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        details.forEach((detail) => {
            if (detail !== targetDetail) {
                detail.removeAttribute("open");
            }
        });
    });
});